package pl.decks.personal.components.layouts.site

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class SiteLayoutScope(
    initMenuState: CollapsableMenuState,
) {
    var menuState by mutableStateOf(initMenuState)
        private set

    fun switchMenuState() {
        menuState = menuState.next()
    }

    fun closeMenu() {
        menuState = CollapsableMenuState.CLOSING
    }

    fun finishClosingMenu() {
        menuState = CollapsableMenuState.CLOSED
    }
}
